export default api => {
	api.addResource("kkmGroup", "kkm-group");
};
